import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    newPath: String
  }

  static targets = [ "panel", "backdrop", "submit" ]

  connect() {
    this.boundCloseOnEscape = this.closeOnEscape.bind(this)
    this.boundOpen = this.open.bind(this)
    this.successTimeout = null

    document.addEventListener("report:open", this.boundOpen)

    const frame = this.element.closest("turbo-frame")
    if (frame && frame.dataset.reportPendingOpen === "true") {
      delete frame.dataset.reportPendingOpen
      this.openModal()
    }
  }

  disconnect() {
    this.clearSuccessTimeout()
    document.removeEventListener("keydown", this.boundCloseOnEscape)
    document.removeEventListener("report:open", this.boundOpen)
  }

  open() {
    this.openModal()
  }

  openModal() {
    this.element.classList.remove("hidden")
    this.element.removeAttribute("aria-hidden")

    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove("hidden")
    }
    if (this.hasPanelTarget) {
      this.panelTarget.classList.remove("hidden")
    }

    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this.boundCloseOnEscape)
  }

  startSubmit() {
    if (!this.hasSubmitTarget) return

    const button = this.submitTarget
    button.disabled = true
    if (!button.dataset.originalText) {
      button.dataset.originalText = button.innerHTML
    }
    button.classList.remove("cursor-pointer")
    button.classList.add("cursor-not-allowed")
    button.innerHTML = this.spinnerHtml("Отправка…")
  }

  endSubmit() {
    if (this.element.querySelector('[data-report-modal-state="success"]')) {
      return
    }

    if (!this.hasSubmitTarget) return

    const button = this.submitTarget
    button.disabled = false
    if (button.dataset.originalText) {
      button.innerHTML = button.dataset.originalText
    }
    button.classList.remove("cursor-not-allowed")
    button.classList.add("cursor-pointer")
  }

  spinnerHtml(text) {
    return `<span class="inline-flex items-center justify-center gap-2">
      <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      <span>${text}</span>
    </span>`
  }

  close() {
    this.clearSuccessTimeout()

    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.add("hidden")
    }
    if (this.hasPanelTarget) {
      this.panelTarget.classList.add("hidden")
    }

    this.element.classList.add("hidden")
    this.element.setAttribute("aria-hidden", "true")

    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.boundCloseOnEscape)

    const frame = this.element.closest("turbo-frame")
    if (frame && this.element.querySelector('[data-report-modal-state="success"]')) {
      frame.setAttribute("src", this.newPathValue)
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  closeOnBackdrop(event) {
    if (!this.hasPanelTarget || this.panelTarget.contains(event.target)) {
      return
    }
    this.close()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  clearSuccessTimeout() {
    if (this.successTimeout) {
      window.clearTimeout(this.successTimeout)
      this.successTimeout = null
    }
  }
}
